import { Col, Page, Row } from "@payping/web-components";
import { SubLayout } from "@/components/SubLayout";
import Sidebar from "./Sidebar";
import Main from "./Main";

const OverviewPage = () => (
  <Page className="tw:mx-auto tw:max-w-[1600px]">
    <SubLayout>
      <Row
        gutter={[
          { xs: 16, sm: 16, md: 16, lg: 16, xl: 32, xxl: 32, xxxl: 32 },
          { xs: 16, sm: 16, md: 16, lg: 16, xl: 32, xxl: 32, xxxl: 32 },
        ]}
      >
        <Col span={24} xxl={18} xl={16}>
          <Main />
        </Col>
        <Col span={24} xxl={6} xl={8}>
          <Sidebar />
        </Col>
      </Row>
    </SubLayout>
  </Page>
);

export default OverviewPage;
